import httpRequest from '@/utils/request'

// 分页查询
export function page(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderCheckExt/page',
        method: 'post',
        data
    })
}

// 创建检验
export function createJY(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderCheckExt/create',
        method: 'post',
        data
    })
}

// 创建检验--改
export function createStandard(data: any): Promise<any> {
    return httpRequest({
        url: 'ext/workorderCheckExt/createStandard',
        method: 'post',
        data
    })
}

// 根据ID查询
export function getBYid(id: any): Promise<any> {
    return httpRequest({
        url: `/ext/workorderCheckExt/${id}`,
        method: 'get'
    })
}

// 获取出入库信息
export function findById(id: Number): Promise<any> {
    return httpRequest({
        url: `/ext/wOutboundExt/findById?id=${id}`,
        method: 'get'
    })
}

// 生产终检数据提交
export function upload (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/endCheckExt/upload',
        method: 'post',
        data
    })
}

// 生产终检数据提交
export function uploadTest (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/endCheckExt/uploadEndCheckNew',
        method: 'post',
        data
    })
}

// 巡检记录创建
export function saveBean (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/deviceCheckExt/saveBean',
        method: 'post',
        data
    })
}

// 获取权限范围内的设备数据
export function getDeviceByCondition (data: any): Promise<any> {
    return httpRequest({
        url: 'ext/deviceExt/getDeviceByCondition',
        method: 'post',
        data
    })
}

// 根据ID查询设备
export function getsbInfo (id: any): Promise<any> {
    return httpRequest({
        url: `ext/deviceExt/${id}`,
        method: 'get'
    })
}
